(function () {
  const ENDPOINT = 'https://endrock.novapower.io/endrockapi/v3/app/littleTrouble/itemsPurchased.php';

  function fetchOrderVelocity(productId) {
    return fetch(`${ENDPOINT}?product_id=${encodeURIComponent(productId)}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Order velocity request failed with status ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        if (json.error || !json.data || !json.data.rows) {
          throw new Error(json.messages || 'Order velocity request returned an error');
        }
        return json.data;
      });
  }

  const FLAME_ICON = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1IiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjUxXzUpIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMDYyNSA4LjQzNzVDMTQuMDYyNSAxMi4wNjE5IDExLjEyNDQgMTUgNy41IDE1QzMuODc1NjMgMTUgMC45Mzc1IDEyLjA2MTkgMC45Mzc1IDguNDM3NUMwLjkzNzUgNS4xNTYyNSAzLjc1IDIuODEyNSAzLjc1IDIuODEyNUg1LjYyNVY0LjIxODc1QzUuNjI1IDQuNzM2NTEgNi4wNDQ3NCA1LjE1NjI1IDYuNTYyNSA1LjE1NjI1QzcuMDgwMjYgNS4xNTYyNSA3LjUgNC43MzY1MSA3LjUgNC4yMTg3NVYwSDkuMzc1QzkuMzc1IDAgMTQuMDYyNSAyLjgxMjUgMTQuMDYyNSA4LjQzNzVaTTkuMzc1IDExLjI1QzkuMzc1IDEyLjI4NTYgOC41MzU1MyAxMy4xMjUgNy41IDEzLjEyNUM2LjQ2NDQ3IDEzLjEyNSA1LjYyNSAxMi4yODU2IDUuNjI1IDExLjI1QzUuNjI1IDguOTA2MjUgNy41IDcuNSA3LjUgNy41QzcuNSA3LjUgOS4zNzUgOC45MDYyNSA5LjM3NSAxMS4yNVoiIGZpbGw9IiNGRjRFMDAiLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1MV81Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiBmaWxsPSJ3aGl0ZSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+Cjwvc3ZnPgo=';

  class OrderVelocity extends HTMLElement {
    connectedCallback() {
      this.hidden = true;

      const mainElement = this.closest('.product-main-element');
      const productId = this.getAttribute('data-product-id') || (mainElement && mainElement.getAttribute('data-product-id'));

      if (!productId) {
        return;
      }

      fetchOrderVelocity(productId)
        .then((data) => {
          const sold = parseInt(data.rows.net_items_sold, 10) || 0;
          const since = parseInt(data.since, 10) || 0;
          this.render(sold, since);
        })
        .catch(() => {
          this.hidden = true;
        });
    }

    render(sold, since) {
      if (!since) {
        return;
      }

      if (sold < 50) {
        return;
      }

      this.hidden = false;
      this.innerHTML = `<img src="${FLAME_ICON}" width="15" height="15" alt="" /> <strong>Going fast! ${sold}+</strong> purchased in the last ${since} days`;
    }
  }

  customElements.define('order-velocity', OrderVelocity);
})();
